import api from "../utils/api";
import { isGuid } from "../utils/string";
import {
  LOGOUT
} from "./types";
import { send as sendAlert } from "./alert";


export const get = ({ staffUuid, personUuid, uuid, startDate, endDate }) => async (dispatch) => {
    try {
        let modifications = "";
        const pivot = isGuid(staffUuid) ? "/staff" : isGuid(personUuid) ? "/person" : "";
        const finalUuid = isGuid(staffUuid) ? staffUuid : isGuid(personUuid) ? personUuid : uuid;
        if (startDate && endDate) modifications += `/r/${startDate}/${endDate}`;

        const res = await api.get(`/staff/payments${pivot}/i/${finalUuid}${modifications}`);
        
        return res.data;
    } catch (err) {
        if (err?.response?.status === 401) dispatch({ type: LOGOUT });
        return { success: false, error: err?.response?.data?.error || err };
    }
}

export const save = ({
    uuid,
    personUuid,
    staffUuid,
    gross,
    source,
    recorded,
    reference,
}) => async (dispatch) => {
    try {
        const res = await api.post(`/staff/payments`, {
            uuid,
            personUuid,
            staffUuid,
            gross,
            source,
            recorded,
            reference,
        });
        if (res.data?.success && Number(res.data?.repostedClocks?.posted || 0) > 0) {
            dispatch(sendAlert(`Posted ${res.data.repostedClocks.posted} previously unposted billable time entr${res.data.repostedClocks.posted === 1 ? "y" : "ies"}.`, "success"));
        }
        if (res.data?.success && res.data?.repostedClocks?.success === false && Number(res.data?.repostedClocks?.remaining || 0) > 0) {
            dispatch(sendAlert(res.data.repostedClocks.errors?.[0]?.message || "Some billable time remains unposted.", "warning"));
        }
        return res.data;
    } catch (error) {
        if (error?.response?.status === 401) dispatch({ type: LOGOUT });
        return { success: false, error: error?.response?.data?.error || error };
    }
}
